/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import {
  TextField,
  DialogTitle,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete
} from '@mui/material';
import { deleteItemFromOrderApi } from '../../../api/orders/OrdersApi';
import { useForm } from 'react-hook-form';
import { getUsersWithPermissionApi } from '../../../api/users/usersApi';
import { deleteItemReason } from '../Shared';
import { useDispatch } from 'react-redux';
import { addSnackbar } from '../../../redux/reducers/ducks/SnackbarDuck';
import { permisssions } from '../../Shared/shared';

export default function DeleteOrderItem({
  deleteItemPopup,
  setDeleteItemPopup,
  outletId,
  callFunc,
  updateTriggerState
}) {
  const dispatch = useDispatch();

  const orderId = deleteItemPopup.orderId;
  const itemId = deleteItemPopup.itemId;

  // calling API to get permited users who can apply discount
  const [users, setUsers] = useState([]);

  const getUsersWithPermission = async () => {
    const response = await getUsersWithPermissionApi(
      outletId,
      permisssions.modifyOrder
    );
    setUsers(response?.data);
  };
  useEffect(() => {
    getUsersWithPermission();
  }, []);

  // handling form of manual discount with useForm hook
  const { register, handleSubmit, setValue, watch, reset } = useForm();
  const inputValue = watch('autocompleteInput');

  const handleChangeUserName = (event) => {
    setValue('userName', event.target.value);
  };

  const [options, setOptions] = useState(deleteItemReason);

  const onSubmit = async (data) => {
    const formData = {
      user: data.userName,
      key: data.key,
      reason: data.autocompleteInput?.title || ''
    };

    try {
      const res = await deleteItemFromOrderApi(orderId, itemId, formData);
      if (res.status == 200) {
        callFunc();
        updateTriggerState(true);
        setDeleteItemPopup({ isOpen: false });
        handleClose();
        dispatch(
          addSnackbar({
            message: 'Item Deleted',
            type: 'success'
          })
        );
      }
    } catch {
      dispatch(
        addSnackbar({
          message: `UnAuthorized`,
          type: 'error'
        })
      );
    }
  };

  const handleClose = () => {
    reset();
    callFunc();
    setDeleteItemPopup('isOpen', false);
  };

  return (
    <div>
      <Dialog
        open={deleteItemPopup?.isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle>Delete Order</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Required Manager Key to Delete this Item
            </DialogContentText>

            <FormControl sx={{ width: '100%' }} size="small">
              <InputLabel>Name</InputLabel>
              <Select
                defaultValue=""
                {...register('userName')}
                label="Name"
                onChange={handleChangeUserName}>
                {users?.map((user, index) => (
                  <MenuItem key={index} value={user._id}>
                    {user.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              autoFocus
              margin="dense"
              name="key"
              label="Manager Key"
              type="password"
              {...register('key')}
              fullWidth
              variant="outlined"
            />

            <Autocomplete
              options={options}
              noOptionsText="Enter to create a new option"
              getOptionLabel={(option) => option.title}
              onChange={(e, newValue) => {
                setValue('autocompleteInput', newValue);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select"
                  variant="outlined"
                  onKeyDown={(e) => {
                    if (
                      e.key === 'Enter' &&
                      options.findIndex((o) => o.title === inputValue) === -1
                    ) {
                      setOptions((o) => o.concat({ title: inputValue }));
                    }
                  }}
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleClose} autoFocus>
              close
            </Button>
            <Button type="submit" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
